import { render, staticRenderFns } from "./PH11V.vue?vue&type=template&id=1484591f"
import script from "./PH11V.vue?vue&type=script&lang=js"
export * from "./PH11V.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports